<template>
    <div class="PmsOrder">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>BBAC专属</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单查询</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="中标合同号">
                        <el-input v-model="searchForm.winBiddingContract" placeholder="中标合同号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="物料号">
                        <el-input v-model="searchForm.materialNumber" placeholder="物料号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {
                            this.currentPage=1;
                            onSearch();
                        }" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    :data="tableData"
                    stripe
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column
                        prop="winBiddingContract"
                        label="中标合同号"
                        fixed="left"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="materialNumber"
                        label="物料号"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="winBiddingDate"
                        label="中标日期"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="winBiddingPrice"
                        label="中标单价（不含税）"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="expectedDeliveryTime"
                        label="BBAC货期"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="reverseContractTime"
                        label="反签合同签署时间"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="inboundTime"
                        label="入库时间"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="inboundNumber"
                        label="实际入库数量"
                        align="right"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="outboundTime"
                        label="出库时间"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="outboundNumber"
                        label="出库实际数量"
                        align="right"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="pmsStatus"
                        label="出库签收状态"
                        fixed="right"
                        width="160">
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="prev, pager, next, sizes"
                        v-if="total>0"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @size-change="onSizeChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            searchForm: {
                company: "",
                materialNumber: "",
                technicalEngineer: "",
                procurementEngineer: "",
            },
            loading: false,
            tableConfig: {
                height: 0,
            },
            total: 0,
            pageSize: 50,
            currentPage: 1,
            tableData: [],
        }
    },
    methods: {
        onSearch() {
            const that = this;
            this.loading = true;
            const cond = Object.fromEntries(
                Object.entries(this.searchForm).filter(([, value]) => value)
            );
            this.$axios.post("/admin/history/order/search",{
                cond,
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                }
            }).finally(() => {
                that.loading = false;
            });
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        this.onSearch();
    },
    mounted() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
